// Limit Paragraph widths. Keep it readable (and in-grid)!


export function initLimitParagraphWidths() {
	// console.log('limit paragraph widths')

	// .is-layout-constrained > ELEMENT:where(:not(.alignleft):not(.alignright):not(.alignfull):not(.alignwide):not(.has-text-align-center):not(.has-text-align-right))
	const constrainedWhereClause = ":where(:not(.alignleft):not(.alignright):not(.alignfull):not(.alignwide):not(.has-text-align-center):not(.has-text-align-right))";
	const constrainedParagraphs = document.querySelectorAll(".wp-block-pullquote, .is-layout-constrained > p" + constrainedWhereClause + ", .is-layout-constrained > .wp-block-heading" + constrainedWhereClause + ", .is-layout-constrained > .wp-block-list" + constrainedWhereClause + ", .is-style-narrow-width--left");
	if (constrainedParagraphs) {
		constrainedParagraphs.forEach(element => {

			// Set constrained margin class ONLY
			// - if set margin-left = "auto !important" // Core WP centering.
			// - AND if factual margin-left > 0
			// - AND (failsafe check) set max-width = "var(--constrained-paragraph-width, --wp--style--global--content-size) !important"

			// Only inline styles :/
			// console.log(element.style)
			// console.log(element.style.marginLeft)
			// console.log(element.style.maxWidth)

			if (getComputedStyle(element).getPropertyValue("--sniff--has-original-margin-left") == 1 && getComputedStyle(element).getPropertyValue("--sniff--has-constrained-paragraph-width") == 1) {

				// console.log('sniffs passed');

				const computedElementStyles = window.getComputedStyle(element);
				if (computedElementStyles.getPropertyValue("margin-left") !== "0px") {
					element.classList.add('has-constrained-margin-left');
				}

			}

		})
	}

	// Repeat for explicitly right-aligned elements.
	const constrainedWhereClauseRightAligned = ":where(.has-text-align-right:not(.alignfull):not(.alignwide))";
	const constrainedParagraphsRightAligned = document.querySelectorAll(".wp-block-pullquote, .is-layout-constrained > p" + constrainedWhereClauseRightAligned + ", .is-layout-constrained > .wp-block-heading" + constrainedWhereClauseRightAligned + ", .is-layout-constrained > .wp-block-list" + constrainedWhereClauseRightAligned);
	if (constrainedParagraphsRightAligned) {
		constrainedParagraphsRightAligned.forEach(element => {

			if (getComputedStyle(element).getPropertyValue("--sniff--has-original-margin-right") == 1 && getComputedStyle(element).getPropertyValue("--sniff--has-constrained-paragraph-width") == 1) {

				// console.log('sniffs passed');

				const computedElementStyles = window.getComputedStyle(element);
				if (computedElementStyles.getPropertyValue("margin-right") !== "0px") {
					element.classList.add('has-constrained-margin-right');
				}

			}

		})
	}


	// For the editor only.
	// block-editor-block-list__block

	const constrainedEditorWhereClause = ":where(:not(.alignleft):not(.alignright):not(.alignfull):not(.alignwide):not(.has-text-align-center):not(.has-text-align-right))";
	const constrainedEditorParagraphs = document.querySelectorAll(".wp-block-pullquote, .is-layout-constrained > p" + constrainedEditorWhereClause + ", .is-layout-constrained > .wp-block-heading" + constrainedEditorWhereClause + ", .is-layout-constrained > .wp-block-list" + constrainedEditorWhereClause + ", .is-style-narrow-width--left");
	if (constrainedEditorParagraphs) {
		constrainedEditorParagraphs.forEach(element => {
			// console.log(element);
			// console.log(getComputedStyle(element).getPropertyValue("--sniff--has-original-margin-left"))
			// console.log(getComputedStyle(element).getPropertyValue("--sniff--has-constrained-paragraph-width"))

			// Set constrained margin class ONLY
			// - if set margin-left = "auto !important" // Core WP centering.
			// - AND if factual margin-left > 0
			// - AND (failsafe check) set max-width = "var(--constrained-paragraph-width, --wp--style--global--content-size) !important"

			// Only inline styles :/
			// console.log(element.style)
			// console.log(element.style.marginLeft)
			// console.log(element.style.maxWidth)

			if (getComputedStyle(element).getPropertyValue("--sniff--has-original-margin-left") == 1 && getComputedStyle(element).getPropertyValue("--sniff--has-constrained-paragraph-width") == 1) {

				// console.log('sniffs passed');

				const computedElementStyles = window.getComputedStyle(element);
				if (computedElementStyles.getPropertyValue("margin-left") !== "0px") {
					element.classList.add('has-constrained-margin-left');
				}

			}

		})
	}

	// const paras = document.querySelectorAll(".wp-block-pullquote, .is-layout-constrained > p:where(:not(.alignleft):not(.alignright):not(.alignfull):not(.alignwide):not(.has-text-align-center):not(.has-text-align-right)), .is-layout-constrained > .wp-block-heading:where(:not(.alignleft):not(.alignright):not(.alignfull):not(.alignwide):not(.has-text-align-center):not(.has-text-align-right)), .is-layout-constrained > .wp-block-list:where(:not(.alignleft):not(.alignright):not(.alignfull):not(.alignwide):not(.has-text-align-center):not(.has-text-align-right)), .is-style-narrow-width--left")
	// => 0


}


